export default __webpack_public_path__ + "static/media/ai72-1-1.de66e56f.jpg";